module.exports = __webpack_public_path__ + "img/trophy2.png";